import { namespaceBundle } from '@/platform/i18n/types';

import './backoffice.interface';
import { backofficeTranslations as en } from './en';
import { backofficeTranslations as es } from './es';
import { backofficeTranslations as pt } from './pt';

export const backofficeI18nBundle = namespaceBundle('backoffice', { es, en, pt });
